import { MapContentLayer } from '../MapContentLayer';
import {LayerSpecification, SymbolLayerSpecification} from 'maplibre-gl';
import { MapContentSource } from '../MapContentSource';
import { MapStyles } from '../../../../../configuration/map-styles';
import { MapPreviewComponent } from '../../map-preview.component';

export class StormMarkerSymbolLayer extends MapContentLayer {

  constructor(
    source: MapContentSource
  ) {
    super('storm-marker-symbol-layer', source);
  }

  toLayerSpecification(): LayerSpecification {
    return {
      id: this.layerId,
      type: 'symbol',
      source: this.sourceRef.sourceId,
      layout: {
        'icon-image': MapPreviewComponent.AZIMUTH_IMAGE,
        'icon-rotate':  ['get', 'heading'],
        'icon-allow-overlap': false,
        'icon-size': 0.18,
        'symbol-sort-key': 0,
        'icon-rotation-alignment': 'map',
      },
      paint: {
        'icon-color': MapStyles.PAUSED_COLOR,
        'icon-halo-width': 0,
      },
    } as SymbolLayerSpecification;
  }
}
